/* BluePet storefront interactions */
(function () {
  'use strict';
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var mainImg = gallery.querySelector('[data-gallery-main]');
    var thumbs = qsa('[data-thumb]', gallery);
    if (!mainImg) return;
    var sources = thumbs.map(function (t) {
      var img = t.querySelector('img');
      return img ? (t.getAttribute('data-full') || img.getAttribute('src')) : '';
    }).filter(Boolean);
    if (!sources.length) return;

    var index = 0;
    var dotsWrap = gallery.querySelector('[data-dots]');
    var counter = gallery.querySelector('[data-gcount]');
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      sources.forEach(function (_, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bp-dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Bild ' + (k + 1) + ' von ' + sources.length);
        b.addEventListener('click', function (e) { e.preventDefault(); show(k); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function show(i) {
      index = (i + sources.length) % sources.length;
      mainImg.setAttribute('src', sources[index]);
      mainImg.setAttribute('alt', thumbs[index] && thumbs[index].querySelector('img') ? (thumbs[index].querySelector('img').getAttribute('alt') || '') : '');
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === index); });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === index);
        d.setAttribute('aria-selected', k === index ? 'true' : 'false');
      });
      if (counter) counter.textContent = (index + 1) + ' / ' + sources.length;
    }

    thumbs.forEach(function (t, k) { t.addEventListener('click', function (e) { e.preventDefault(); show(k); }); });
    qsa('[data-gnav-prev]', gallery).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); show(index - 1); }); });
    qsa('[data-gnav-next]', gallery).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); show(index + 1); }); });

    /* Touch swipe on the main stage (mobile-first) */
    var stage = gallery.querySelector('[data-swipe]') || mainImg.parentNode;
    if (stage && sources.length > 1) {
      var x0 = null, y0 = null, moved = false;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; moved = false;
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (x0 === null || e.touches.length !== 1) return;
        var dx = Math.abs(e.touches[0].clientX - x0);
        var dy = Math.abs(e.touches[0].clientY - y0);
        if (dx > 12 && dx > dy) moved = true;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (moved && Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
        x0 = null; y0 = null; moved = false;
      }, { passive: true });
    }

    show(0);
  }

  function initCarousel() {
    qsa('[data-carousel]').forEach(function (car) {
      var prev = car.parentNode.querySelector('[data-cnav-prev]');
      var next = car.parentNode.querySelector('[data-cnav-next]');
      var step = function () { var c = car.querySelector('.ot-card'); return c ? c.getBoundingClientRect().width + 16 : 260; };
      if (prev) prev.addEventListener('click', function () { car.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { car.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  function initDrawer() {
    var drawer = document.querySelector('[data-bp-drawer]');
    if (!drawer) return;
    var toggles = qsa('[data-bp-drawer-toggle]');
    function open() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); }); }
    function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); }); }
    toggles.forEach(function (t) { t.addEventListener('click', open); });
    qsa('[data-bp-drawer-close]', drawer).forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function initSearch() {
    var panel = document.querySelector('[data-bp-search]');
    if (!panel) return;
    var open = qsa('[data-bp-search-toggle]');
    var close = qsa('[data-bp-search-close]', panel);
    open.forEach(function (b) { b.addEventListener('click', function () {
      panel.hidden = !panel.hidden;
      if (!panel.hidden) { var i = panel.querySelector('input'); if (i) i.focus(); }
    }); });
    close.forEach(function (b) { b.addEventListener('click', function () { panel.hidden = true; }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') panel.hidden = true; });
  }

  function initQty() {
    qsa('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      if (!input) return;
      if (minus) minus.addEventListener('click', function () { input.value = Math.max(0, (parseInt(input.value, 10) || 1) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
      if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 0) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
    });
  }

  function initCartForms() {
    qsa('form[data-cart-update]').forEach(function (form) {
      var input = form.querySelector('input[name="updates[]"]');
      if (input) input.addEventListener('change', function () { form.submit(); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGallery(); initCarousel(); initDrawer(); initSearch(); initQty(); initCartForms();
  });
})();
